<template>
  <div>
    <div class="title--area">
        <h2>{{ menuNm }}</h2>
    </div>
    <div class="data--container">
      <div class="flex--box flex--box--1_2 btn--on" v-resize @resize="onResize">
        <div class="btn--area space--between">
            <button type="button" class="btn btn--black" @click="add">추가</button>
          <div class="btns">
            <button type="button" class="btn btn--white" @click="searchGridData">조회</button>
            <button type="button" class="btn btn--white" @click="save">저장</button>
            <button type="button" class="btn btn--white" @click="del">삭제</button>
          </div>
        </div>
        <table class="table">
          <caption>사용자관리 테이블</caption>
          <tbody>
            <tr>
              <th class="necessary">사용자명</th>
              <td><input type="text" v-model="userNm"></td>
              <th class="necessary">아이디</th>
              <td><input type="text" v-model="userId"></td>
              <th class="necessary">사용여부</th>
              <td>
                <select v-model="useYn" id="useYn">
                  <option value="">전체</option>
                  <option value="Y">예</option>
                  <option value="N">아니오</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="grid--area">
          <grid ref="grid2"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :language="'ko'"
              @click="gridClick"
              @check="gridCheck">
          </grid>
        </div>
      </div>
    </div>
    <a href="#modalPwd" id="showPwdModal"></a>

    <!-- 비밀번호변경 모달 -->
    <div class="modal list" id="modalPwd" style="width:500px; display:none;">
      <div class="modal--header txt-c">
        <h2>비밀번호변경</h2>
      </div>
      <div class="modal--content">
        <table class="table">
          <caption>설문기본정보관리 테이블</caption>
          <tbody>
            <tr>
              <th class="necessary txt-l pdl10">신규비밀번호</th>
              <td><input type="password" id="userPwd"></td>
            </tr>
            <tr>
              <th class="necessary txt-l pdl10">신규비밀번호확인</th>
              <td><input type="password" id="userPwdConfirm"></td>
            </tr>
          </tbody>
        </table>
        <p class="guide--txt">비밀번호는 6 ~ 16자리로 입력하시고 비밀번호는 문자, 숫자의 조합으로 입력해주세요.</p>
      </div>
      <div class="modal--footer">
        <button type="button" class="btn btn--black" @click="savePwd">적용</button>
        <button type="button" class="btn btn--white" @click="closeModal">취소</button>
      </div>
    </div>
  </div>
</template>

<script>
import 'tui-date-picker/dist/tui-date-picker.css'
import 'tui-time-picker/dist/tui-time-picker.css'
import { Grid } from '@toast-ui/vue-grid'
import $ from 'jquery'
import userMngApi from '@/api/admin/UserMng'

export default {
  name: 'UserMng',
  components: {
    grid: Grid
  },

  data () {
    return {
      menuNm: this.$route.name,
      userNm: '',
      userId: '',
      checkUserIdFlag: false,
      useYn: '',
      addBtn: '',
      $modalCnt: '',
      gridProps: {
        data: [],
        columns: [
          {
            header: 'ID',
            name: 'userId',
            width: 150,
            align: 'center',
            editor: 'text',
            validation: { required: true }
          },
          {
            header: '비밀번호',
            name: 'pwd',
            width: 150,
            align: 'center'
          },
          {
            header: '비밀번호',
            name: 'userPwd',
            width: 150,
            align: 'center',
            editor: 'text',
            validation: { required: true }
          },
          {
            header: '사용자명',
            name: 'userNm',
            width: 150,
            align: 'center',
            editor: 'text',
            validation: { required: true }
          },
          {
            header: '이메일',
            name: 'userEmail',
            width: 200,
            align: 'left',
            editor: 'text'
          },
          {
            header: '사용여부',
            name: 'useYn',
            width: 150,
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          },
          {
            header: '로그인실패횟수',
            name: 'loginCount',
            width: 150,
            align: 'center',
            editor: 'text'
          },
          {
            header: '생성일자',
            name: 'fstRegDate',
            width: 150,
            align: 'center'
          },
          {
            header: '최종로그인시간',
            name: 'lstLoginDate',
            width: 150,
            align: 'center'
          },
          {
            header: '최종로그아웃시간',
            name: 'lstLogoutDate',
            width: 150,
            align: 'center'
          }
        ],
        options: {
          rowHeaders: ['checkbox'],
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 550,
          selectionUnit: 'row',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick'
        }
      },
      rowKey: '',
      attribute: {
        expanded: true
      }
    }
  },

  watch: {

  },

  created () {
    this.searchGridData()
  },
  methods: {
    onResize () {
      this.$refs.grid2.invoke('refreshLayout')
    },
    // 사용자 그리드 조회
    async searchGridData () {
      const params = {
        userNm: this.userNm,
        userId: this.userId,
        useYn: this.useYn
      }
      const userData = await userMngApi.adminUserList(params)
      this.gridProps.data = userData

      if (this.gridProps.data !== undefined) {
        this.$refs.grid2.invoke('resetData', this.gridProps.data)

        const rowCnt = this.$refs.grid2.invoke('getRowCount')

        for (let i = 0; i < rowCnt; i++) {
          const rowKey = this.$refs.grid2.invoke('getRowAt', i).rowKey
          this.$refs.grid2.invoke('disableCell', rowKey, 'userId')
        }
        this.$refs.grid2.invoke('hideColumn', 'userPwd')
      }
    },

    // 그리드 row 추가
    add () {
      // this.addBtn += 'Y'
      this.$refs.grid2.invoke('appendRow', { useYn: 'Y', loginCount: 0 }, { focus: false })
    },

    // 하위 그리드 체크박스 선택 이벤트
    gridCheck (ev) {
      if (this.$refs.grid2.invoke('getValue', ev.rowKey, 'userId') == null) {
        this.$refs.grid2.invoke('removeRow', ev.rowKey)
      }
    },

    // 그리드 내 입력, 수정 event
    async save () {
      if (!this.gridRequiredCheck()) return // 필수항목 값 체크
      const params = this.$refs.grid2.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows

      if (params.createdRows.length === 0 && params.updatedRows.length === 0) { // 추가 또는 수정된 row가 없다면
        return
      } else if (params.updatedRows.length > 0) { // 수정된 row가 있다면 (아이디 중복 검사 X)
        this.saveAlert(params)
      } else if (params.createdRows.length > 0) { // 추가된 row가 있다면 (아이디 중복 검사 O)
        const userIdList = []
        const userIdData = await userMngApi.userIdList() // 데이터의 사용자 아이디 조회

        for (let i = 0; i < userIdData.length; i++) {
          if (userIdList.indexOf(userIdData[i].userId) < 0) {
            userIdList.push(userIdData[i].userId) // 데이터의 userId를 userIdList에 넣어준다
          }
        }

        const rowCnt = this.$refs.grid2.invoke('getRowCount')

        for (let i = 0; i < rowCnt; i++) { // 현재 그리드의 row갯수만큼 for문
          const userId = this.$refs.grid2.invoke('getRowAt', i).userId

          if (userIdList.indexOf(userId) > 0) { // 현재 그리드의 userId와 데이터의 userId를 비교하여 중복된 아이디가 있다면
            this.checkUserIdFlag = true // 플래그를 true로 변경
          } else { // 중복된 아이디가 없다면
            this.checkUserIdFlag = false // 플래그를 false으로 변경
          }
        }

        if (!this.checkUserIdFlag) { // 중복된 아이디가 없다면 (this.checkUserIdFlag가 false라면)
          this.saveAlert(params) // 저장 알림창 띄우기
        } else {
          alert('중복된 아이디가 존재합니다.')
        }
      }
    },

    gridRequiredCheck () { // 필수 입력값 체크
      const rowCnt = this.$refs.grid2.invoke('getRowCount')
      for (let i = 0; i < rowCnt; i++) {
        const userId = this.$refs.grid2.invoke('getRowAt', i).userId
        const userPwd = this.$refs.grid2.invoke('getRowAt', i).userPwd
        const userNm = this.$refs.grid2.invoke('getRowAt', i).userNm

        if (userId == null || userId === '') {
          alert('아이디를 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'userId')
          return false
        } else if (userPwd == null || userPwd === '') {
          alert('비밀번호를 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'userPwd')
          return false
        } else if (userNm == null || userNm === '') {
          alert('사용자명을 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'userNm')
          return false
        }
      }

      return true
    },

    async saveAlert (params) { // 저장 알림창
      if (window.confirm('저장하시겠습니까?')) {
        const result = await userMngApi.saveAdminUser(params)
        if (result.result) {
          alert('저장되었습니다.')
          this.searchGridData()
        } else {
          alert('오류가 발생했습니다. 다시 시도해주세요.')
        }
      }
    },

    // 그리드 내 삭제 event
    async del () {
      const params = this.$refs.grid2.invoke('getCheckedRows') // check 된 row만 삭제

      if (params.length > 0) {
        if (window.confirm('삭제하시겠습니까?')) {
          const result = await userMngApi.deleteAdminUser(params)

          if (result.result) {
            alert('삭제되었습니다.')
            this.searchGridData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      } else {
        alert('삭제하실 항목을 선택해주세요.')
      }
    },

    gridClick (ev) {
      if (ev.columnName === 'pwd') {
        this.$nextTick(function () {
          this.rowKey = ev.rowKey
          this.setModal($('#showPwdModal'))
        })
      }
    },

    // 모달창 세팅
    setModal (target) {
      let $modalCnt = $(target).attr('href')
      $modalCnt = $($modalCnt)

      this.$modalCnt = $modalCnt

      $modalCnt.before("<div id='mask'></div>")

      $(window).on('resize', this.centerPosition)

      $('#modalPwd').css('z-index', '1060')

      $('#mask').add($modalCnt).stop().fadeIn('fast')
      $modalCnt.attr('tabIndex', 0).focus()

      this.centerPosition()

      $('#mask').click(function () {
        $('#userPwd').val('')
        $('#userPwdConfirm').val('')
        $('#mask').add($modalCnt).stop().fadeOut('fast', function () {
          $('#mask').remove()
        })
      })
    },
    // 모달창 사이즈 조정
    centerPosition () {
      const topPos = ($(window).height() - $(this.$modalCnt).outerHeight()) / 2
      // const leftPos = ($(window).width() - $(this.$modalCnt).outerWidth()) / 2

      // $(this.$modalCnt).css({ top: topPos, left: leftPos })
      $(this.$modalCnt).css({ top: topPos })
    },

    // 모달창 적용버튼
    savePwd () {
      const userPwd = $('#userPwd').val()
      const userPwdConfirm = $('#userPwdConfirm').val()

      if (userPwd.length === 0) { // 비밀번호 값이 없다면
        alert('비밀번호를 입력해주세요.')
        $('#userPwd').focus()
      } else {
        if (this.checkPwd() === true) {
          if (userPwdConfirm === '') { // 비밀번호확인 값이 없다면
            alert('비밀번호 확인을 입력해주세요.')
            $('#userPwdConfirm').focus()
          } else if (userPwdConfirm !== userPwd) { // 비밀번호와 비밀번호확인 값이 일치하지 않다면
            alert('비밀번호가 일치하지 않습니다.')
            $('#userPwdConfirm').focus()
          } else { // 값이 모두 일치한다면
            if (confirm('적용하시겠습니까?')) {
              this.$refs.grid2.invoke('setValue', this.rowKey, 'userPwd', userPwd) // 숨은 비번값 userPwd
              this.$refs.grid2.invoke('setValue', this.rowKey, 'pwd', userPwd) // 비번값 pwd

              $('#userPwd').val('')
              $('#userPwdConfirm').val('')
              this.closeModal()
            }
          }
        }
      }
    },

    checkPwd () {
      var password = $('#userPwd').val()

      if (password.length < 6) {
        alert('비밀번호는  6~16자리로 입력해주세요.')
        $('#userPwd').val('')
        return false
      }

      if (!password.match(/([a-zA-Z0-9].*[!,@,#,$,%,^,&,*,?,_,~])|([!,@,#,$,%,^,&,*,?,_,~].*[a-zA-Z0-9])|([a-zA-Z].*[0-9])|([a-zA-Z].*[!,@,#,$,%,^,&,*,?,_,~])/)) {
        alert('비밀번호는 문자, 숫자의 조합으로 입력해주세요.')
        $('#userPwd').val('')
        return false
      }

      // const SamePass0 = 0 // 동일문자 카운트
      // const SamePass1 = 0 // 연속성(+) 카운드
      // const SamePass2 = 0 // 연속성(-) 카운드

      var chrPass0
      var chrPass1
      var chrPass2

      // 동일문자연속체크
      for (var i = 0; i < password.length; i++) {
        chrPass0 = password.charAt(i)
        chrPass1 = password.charAt(i + 1)
        chrPass2 = password.charAt(i + 2)

        if (chrPass0 === chrPass1 && chrPass1 === chrPass2) {
          alert('동일문자를 연속해서 3번 이상 사용할 수 없습니다.')
          $('#userPwd').val('')
          return false
        }
      }

      // 연속문자체크
      for (let i = 0; i < password.length; i++) {
        chrPass0 = password.charAt(i)
        chrPass1 = password.charAt(i + 1)
        chrPass2 = password.charAt(i + 2)

        // 연속성(+) 카운드
        if (chrPass0.charCodeAt(0) - chrPass1.charCodeAt(0) === 1 && chrPass1.charCodeAt(0) - chrPass2.charCodeAt(0) === 1) {
          // SamePass_1 = SamePass_1 + 1
          alert('연속된 문자열(123 또는 321, abc, cba 등)을\n 3자 이상 사용 할 수 없습니다.')
          $('#userPwd').val('')
          return false
        }

        // 연속성(-) 카운드
        if (chrPass0.charCodeAt(0) - chrPass1.charCodeAt(0) === -1 && chrPass1.charCodeAt(0) - chrPass2.charCodeAt(0) === -1) {
        //   SamePass_2 = SamePass_2 + 1
          alert('연속된 문자열(123 또는 321, abc, cba 등)을\n 3자 이상 사용 할 수 없습니다.')
          $('#userPwd').val('')
          return false
        }
      }

      return true
    },

    // 모달창 취소버튼
    closeModal () {
      $('#userPwd').val('')
      $('#userPwdConfirm').val('')
      $('#mask').add(this.$modalCnt).stop().fadeOut('fast', function () {
        $('#mask').remove()
      })
    }
  }
}
</script>

<style scoped>
</style>
